import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { get } from 'lodash'
import AnesthesiaType from '../Classes/ClvrAnesthesiaType'
import { AnesthesiaTypeDto } from '../Type/AnesthesiaTypeDto'

export class AnesthesiaTypeApiAdapter implements ApiDataAdapter<AnesthesiaType> {
    public createClass(apiData: AnesthesiaTypeDto): AnesthesiaType {
        return new AnesthesiaType({
            id: get(apiData, 'id'),
            name: get(apiData, 'name'),
        })
    }
}
